/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useState, useEffect } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import Loader from 'react-loader-spinner';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import { useQuery } from 'react-query';
import { Button, Modal } from 'react-bootstrap';
import { useLocalStorage } from 'react-use';
import { toast } from 'react-toastify';
import { numberWithCommas } from '../Utils';


export const PropertyViewingSheetForm = () => {
  const location = useLocation();
  const [values, setValues] = useState({});
  const [name, setName] = useLocalStorage('name', '');
  const [surname, setSurname] = useLocalStorage('surname', '');
  const [passportnumber, setPassportNumber] = useLocalStorage(
    'passportnumber',
    '',
  );
  const [companyName, setCompanyName] = useLocalStorage(
    'companyName',
    '',
  );
  const [companyNameReg, setCompanyNameReg] = useLocalStorage(
    'companyNameReg',
    '',
  );
  const [addressType, setAddressType] = useLocalStorage(
    'addressType',
    '',
  );
  const [staffMemberId] = useState(
    localStorage.getItem('staffMemberId')
  );
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [sigPad, setSigPad] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [emailShow, setEmailShow] = useState(false);
  const [emails, setEmails] = useState('');
  const [userId] = useState(localStorage.getItem('userId'));
  const [userEmail] = useState(JSON.parse(localStorage.getItem('staffMemberInfo')).mainEmail);
  const branchId = JSON.parse(localStorage.getItem('staffMemberInfo')).branchAccess[0]?.id;
  const [errorEmail, setErrorEmail] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    let token = localStorage.getItem('token');
    axios.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${token}`;

    document.title = 'Listing Form';
  }, []);

  useEffect(() => {
    if (isSubmitting) {
      postViewingSheet();
    }
  }, [isSubmitting, sigPad, values.signature]);

  useEffect(() => {
    setEmails(location?.state?.buyerEmail);
  }, [
    location?.state?.buyerEmail,
  ]);

  const fetchDocument = () => {
    const options = {
      method: 'GET',
      url: `/DocumentTemplate/GetViewingSheetForMobile/${location?.state?.buyerSpecId}`,
    };

    return axios
      .request(options)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw new Error('Server error');
      });
  };

  const postEmailMessage = () => {

    let data = {
      RecordId: parseInt(location?.state?.buyerSpecId),
      Signature1: sigPad.toDataURL(),
      BranchId: branchId,
      BodyText: "xxx", //Set by backend
      CompanyId: 1, //Set by backend
      ContextId: 3, //Set by backend,
      Description: "xxx", //Set by backend
      SubjectText: "xxx", //Set by backend
      TemplateType: 1, //Set by backend
      SelectedProperties: location?.state?.selectedPropertiesIds,
      StaffMemberId: staffMemberId,
      EmailMessage: {
        message: dataDocument?.bodyText,
        sys_UserId: userId,
        toAddress: emails,
        fromAddress: userEmail,
        subject: `Viewing Sheet ${location?.state?.buyerName}`,
      }
    };

    const config = {
      method: 'POST',
      url: '/DocumentTemplate/PostEmailMessageForViewingSheet',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(data),
    };

    return axios
      .request(config)
      .then((response) => {
        toast.success(`Email Sent`, {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        return response.data;
      })
      .catch((error) => {
        toast.error(`Internal Server Error, please contact support.`, {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: false,
          progress: undefined,
        });
      });
  };

  const {
    isLoading: isLoadingDocument,
    data: dataDocument,
    isError,
  } = useQuery(['document'], fetchDocument, {
    refetchOnWindowFocus: false
  });

  const getCurrentDate = () => {
    let d = new Date();
    let date = d.getDate();
    let month = d.getMonth() + 1;
    let year = d.getFullYear();
    let hour = d.getHours();
    let minutes = d.getMinutes();

    return `${month}/${date}/${year} ${hour}:${minutes}`;
  };

  const goBack = () => {
    navigate('/');
  };

  const email = () => {
    setEmailShow(true);
  };

  const handleSubmit = (event) => {
    if (event) event.preventDefault();
    setIsSubmitting(true);
  };

  const handleModalShowHide = () => {
    setModalShow(false);
  };

  const handleChangeEmail = (e) => {
    setErrorEmail('');
    setEmails(e.target.value);
  };

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const handleSubmitEmail = (event) => {
    event.preventDefault();
    let emailsAddresses = emails.split(';');
    let txt = '';
    let email = [];
    for (let x in emailsAddresses) {
      txt = validateEmail(emailsAddresses[x]);
      email.push(txt);
    }

    if (!emails) {
      setErrorEmail('Email is required');
      return;
    }

    if (emailsAddresses.length > 1 && email.includes(false)) {
      setErrorEmail(
        'There is an error in one of the email addresses.',
      );
      return;
    }

    if (email.includes(false)) {
      setErrorEmail('Invalid email address.');
      return;
    }

    setEmailShow(false);
    let elements = emailsAddresses.join(';');
    postEmailMessage();
  };

  const handleClearSignature = () => {
    sigPad.clear();
  };

  const trim = () => {
    setSigPad({
      trimmedDataURL: sigPad
        .getTrimmedCanvas()
        .toDataURL('image/png'),
    });
  };

  const postViewingSheet = async (e) => {
    let data = {
        RecordId: parseInt(location?.state?.buyerSpecId),
        Signature1: sigPad.toDataURL(),
        BranchId: branchId,
        BodyText: "xxx", //Set by backend
        CompanyId: 1, //Set by backend
        ContextId: 3, //Set by backend,
        Description: "xxx", //Set by backend
        SubjectText: "xxx", //Set by backend
        TemplateType: 1, //Set by backend,
        SelectedProperties: location?.state?.selectedPropertiesIds,
        StaffMemberId: staffMemberId
      };

    const config = {
      method: 'POST',
      url: '/DocumentTemplate/PostBuyerViewingSheet',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(data),
    };

    try {
      const data = await axios(config);
      if (data.status == 200 || data.status == 201) {
        toast.success(
          `Viewing Sheet Saved`,
          {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
        navigate(-1);
      }
    } catch (err) {
      setIsSubmitting(false);
        toast.error(
          `Internal Server Error, please contact support.`,
          {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
    }
  };

  if (isLoadingDocument) {
    return (
      <div className="container">
        <div className="row justify-content-center align-items-center vh-100">
          <Loader
            type="TailSpin"
            color="black"
            height="50"
            width="50"
          />
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="container">
        <div className="row justify-content-center align-items-center vh-100">
          <h1>Server is down, please try again later </h1>
        </div>
      </div>
    );
  }
  return (
    <div className="container p-0 vh-100">
      <div className="row justify-content-center align-items-center ">
        <div className="col-12 col-md-12 col-xl-12">
          <div className="h4 mb-3 ml-0 font-weight-bold">
            {dataDocument?.description}
          </div>
        </div>
      </div>
      <div className="row justify-content-center align-items-center ">
      <div className="col-12">
          <div className="h4 mb-3 ml-0 font-weight-bold">
            <i className="fa fa-file-alt mr-2" aria-hidden="true"></i>
            {location?.state?.buyerName} Viewing Sheet
          </div>
        </div>
        <div className="col-12 col-md-12 col-xl-12">
          <form onSubmit={handleSubmit} id="validation-form">
            <div
              dangerouslySetInnerHTML={{
                __html: dataDocument?.bodyText,
              }}
            ></div>
            <div className="pt-1 pb-3">
              <p className='font-weight-bold'>Properties viewed:</p>
            {location?.state?.properties &&
              React.Children.toArray(
                location?.state?.properties?.map((property, index) => (
                  <p>Property Ref: {property.propertyRef} - {property.shortDescription} - 
                  €{
                    property.forSaleOrToLet === false
                      ? numberWithCommas(property.propertyForSale?.price)
                      : numberWithCommas(property.propertyToLet?.longLetRate)
                  }</p>
                )))}
            </div>
            <p>Client's Signature:</p>
            <SignatureCanvas
              penColor="blue"
              backgroundColor="white"
              clearOnResize={false}
              canvasProps={{
                height: 200,
                className: 'sigPad  w-100',
              }}
              ref={(ref) => {
                setSigPad(ref);
              }}
            />
            <p
              type="clear"
              className="btn btn-primary d-block mb-3 mt-3"
              onClick={() => handleClearSignature()}
            >
              Clear Signature
            </p>
            <div className="d-flex justify-content-between align-items-center mt-2 mb-4">
              <p className="d-block text-primary mb-4 mt-4">
                {getCurrentDate()}
              </p>
              <p
                className="btn btn-success d-block p-2 mb-0"
                onClick={email}
              >
                Email
              </p>
              <button
                type="submit"
                className="btn btn-success d-block"
              >
                Save
              </button>
            </div>
            <Modal show={modalShow} backdrop="static">
              <Modal.Header
                closeButton
                onClick={handleModalShowHide}
              ></Modal.Header>
              <Modal.Body>
                <div className="d-flex flex-column justify-content-center align-items-center ">
                  <i
                    className="fa fa-check-circle fa-5x mb-3"
                    aria-hidden="true"
                  ></i>
                  <p>
                    Thanks {name} {surname}
                  </p>
                  <p>
                    Property Listing Agreement form stored
                    successfully
                  </p>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={goBack}>
                  Home
                </Button>
              </Modal.Footer>
            </Modal>
            <Modal show={emailShow} backdrop="static">
              <Modal.Header
                closeButton
                onClick={() => setEmailShow(false)}
              >
                <Modal.Title><span className='font-weight-bold'>Send Agreement Email</span></Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>
                  Please enter the email addresses you would like to
                  send the property listing form to
                </p>
                <div className="form-group">
                  <label className="form-label" htmlFor="emails">
                    Emails:
                  </label>
                  <input
                    id="emails"
                    autoComplete="off"
                    className={`form-control ${
                      errorEmail && 'border-danger'
                    } d-block w-100 mb-2`}
                    type="text"
                    name="emails"
                    value={emails}
                    onChange={handleChangeEmail}
                    required
                  />
                  {errorEmail && (
                    <small className="text-danger">
                      {errorEmail}
                    </small>
                  )}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="success" onClick={handleSubmitEmail}>
                  Send
                </Button>
              </Modal.Footer>
            </Modal>
          </form>
        </div>
      </div>
    </div>
  );
};
